/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Context/Handlers/HandleError";

addToEndOfChain(chain, (props: any) => {
    const err = props?.parameter?.error;
    props.dispatch({
        type: "xError/setMessage",
        message: err?.errorMessage || err?.errorJson?.message || err?.message,
    });
});
